import { render, staticRenderFns } from "./LightScrollableTable.vue?vue&type=template&id=27ac5c0c&scoped=true&"
import script from "./LightScrollableTable.vue?vue&type=script&lang=ts&"
export * from "./LightScrollableTable.vue?vue&type=script&lang=ts&"
import style0 from "./LightScrollableTable.vue?vue&type=style&index=0&id=27ac5c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac5c0c",
  null
  
)

export default component.exports